import { Component, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { PanelsInterfaceComponent, PanelsInterfaceComponentBase } from '../panels-interface.component';

@Component({
  selector: 'project-panel-comments',
  templateUrl: './comments.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsCommentsComponent extends PanelsInterfaceComponentBase implements PanelsInterfaceComponent {
  public editMode: boolean;

  constructor(protected readonly _changeDetectorRef: ChangeDetectorRef) {
    super(_changeDetectorRef);
  }

  ngOnInit() {
    this.titleFieldDef = {
      name: 'comments.panel_name',
      label: this.panelDef.title,
      type: 'text',
    };
    this.panelColor = this.panelDef?.color;
  }

  cancelEdits(): void {
    this.toggleEditMode(false);
  }
}
